import React from 'react'

import { Formik } from 'formik'

import { Button, Modal, Form } from '_zari/core'

import * as FormGroups from './formGroups'

const NuevoModal = ({ show, handleClose, modalData, submitFunction }) => {
  const formInitialValues = React.useMemo(() => {
    return {
      cuentaContable: modalData.cuentaContable || '',
      cuentaContableInfo: modalData.cuentaContableInfo || '',
      dh: modalData.dh || ''
    }
  }, [modalData])

  const onSubmit = React.useCallback(
    data => {
      submitFunction(modalData._idFila, data)
    },
    [modalData, submitFunction]
  )

  return (
    <Modal show={show} centered size='sm'>
      <Modal.Header>
        <Modal.Title>Editar Cuenta</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, values, setFieldValue, handleSubmit }) => (
          <>
            <Modal.Body>
              <Form>
                <FormGroups.CuentaContableFormGroup
                  iError={errors.cuentaContable}
                  iTouched={touched.cuentaContable}
                  iValue={values.cuentaContableInfo}
                  setFieldValue={setFieldValue}
                />
                <FormGroups.DhFormGroup
                  iError={errors.dh}
                  iTouched={touched.dh}
                  fIsSubmitting={isSubmitting}
                />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Guardar</Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(NuevoModal)
